const CHUNK_LOAD_ERROR_PATTERN = /Loading chunk [\w-]+ failed/i;
// Chrome: "Failed to fetch dynamically imported module",
// Safari: "Importing a module script failed.",
// Firefox: "error loading dynamically imported module".
const DYNAMIC_IMPORT_FAILED_PATTERN =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;
const ROUTER_LAZY_LOAD_STACK_PATTERN =
  /loadChildren|_router-chunk|chunk-[\w]+\.js/i;

export const STALE_CHUNK_RELOAD_PENDING_KEY = "stale-chunk-reload-pending";
export const STALE_CHUNK_RELOAD_ATTEMPTS_KEY = "stale-chunk-reload-attempts";

const MAX_RELOAD_ATTEMPTS = 1;

function isStaleChunkMessage(message: string): boolean {
  return (
    CHUNK_LOAD_ERROR_PATTERN.test(message) ||
    DYNAMIC_IMPORT_FAILED_PATTERN.test(message)
  );
}

function hasRouterLazyLoadStack(stack: string | undefined): boolean {
  if (!stack) {
    return false;
  }

  return ROUTER_LAZY_LOAD_STACK_PATTERN.test(stack);
}

export function isStaleChunkError(error: unknown): boolean {
  if (error instanceof Error) {
    if (error.name === "ChunkLoadError") {
      return true;
    }

    if (isStaleChunkMessage(error.message)) {
      return true;
    }

    if (error instanceof SyntaxError && hasRouterLazyLoadStack(error.stack)) {
      return true;
    }

    if (
      hasRouterLazyLoadStack(error.stack) &&
      isStaleChunkMessage(error.message)
    ) {
      return true;
    }

    return false;
  }

  if (typeof error === "string") {
    return isStaleChunkMessage(error);
  }

  return false;
}

export function wasStaleChunkReloadTriggered(): boolean {
  return sessionStorage.getItem(STALE_CHUNK_RELOAD_PENDING_KEY) === "true";
}

export function clearStaleChunkReloadPending(): void {
  sessionStorage.removeItem(STALE_CHUNK_RELOAD_PENDING_KEY);
}

export function reloadForStaleChunk(): boolean {
  if (wasStaleChunkReloadTriggered()) {
    return true;
  }

  const attempts = Number(
    sessionStorage.getItem(STALE_CHUNK_RELOAD_ATTEMPTS_KEY) ?? 0
  );

  if (attempts >= MAX_RELOAD_ATTEMPTS) {
    return false;
  }

  sessionStorage.setItem(STALE_CHUNK_RELOAD_ATTEMPTS_KEY, String(attempts + 1));
  sessionStorage.setItem(STALE_CHUNK_RELOAD_PENDING_KEY, "true");
  window.location.reload();

  return true;
}
